import _ from 'lodash'
import { MaterialSummaryDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { MaterialKeywordsFilter } from 'store/Project/ProjectTypes'

export function showPartTypeBasedOnMaterials(
  materialSummary: MaterialSummaryDto,
  filter: MaterialKeywordsFilter
) {
  const enabledGroups = Object.keys(filter.enabledFilters || {})
  // console.log('enabledGroups', enabledGroups)

  if (enabledGroups.length === 0) {
    return Object.keys(materialSummary?.tokens || {}).length === 0
  }

  if (_.isEmpty(materialSummary.tokens)) {
    return false
  }

  let shouldShowThisRow = true

  for (const filterGroup of Object.keys(filter.enabledFilters)) {
    // for the same filter group, we need to check if the row contains all the enabled keywords
    const enabledKeywords = filter.enabledFilters[filterGroup]

    if (!enabledKeywords?.length) {
      continue
    }

    const rowKeywords = materialSummary?.tokens[filterGroup]

    shouldShowThisRow =
      shouldShowThisRow &&
      enabledKeywords.some((filterToken) =>
        rowKeywords?.some(
          (rowToken) => rowToken.originalKeyword === filterToken.originalKeyword
        )
      )

    if (!shouldShowThisRow) {
      break
    }
  }

  return shouldShowThisRow
}
